import { ConfigProvider } from '@bfe/lux';
import { FC, PropsWithChildren } from 'react';

const ThemeProvider: FC<PropsWithChildren> = ({ children }) => {
  return (
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: '#f7a600',
        },
      }}
    >
      {children}
    </ConfigProvider>
  );
};

export default ThemeProvider;
